import React from "react";
import PropTypes from "prop-types";

const productItem = ({ product, bgColor, color, text, onDisplay }) => {
  return (
    <div
      className="ProductItem"
      style={{
        backgroundColor: bgColor,
        color: color,
      }}
      onClick={() => onDisplay(product)}
    >
      {text}
    </div>
  );
};

productItem.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
};
export default productItem;
